import { Badge } from '../../components/ui/Badge'
import type { RoadmapStatus } from '../../api/types'

const CONFIG: Record<RoadmapStatus, { label: string; variant: 'neutral' | 'info' | 'success' | 'danger' }> = {
  PLANNED: { label: 'Geplant', variant: 'neutral' },
  IN_PROGRESS: { label: 'In Arbeit', variant: 'info' },
  COMPLETED: { label: 'Abgeschlossen', variant: 'success' },
  DELAYED: { label: 'Verzögert', variant: 'danger' },
}

export function RoadmapStatusBadge({ status }: { status: RoadmapStatus }) {
  const config = CONFIG[status]
  return <Badge variant={config.variant}>{config.label}</Badge>
}
